module.exports = __webpack_public_path__ + "img/societalBenefits.4e0795c2.jpeg";